import { useSettings } from "~/store/settings";

const initialiseLocale = async () => {
	const store = useSettings();
	const host = useRequestURL().hostname;

	let locale: string | undefined = undefined;
	if (host?.indexOf("localhost") !== -1 || host?.indexOf("synapse") !== -1) {
		if (useNuxtApp().ssrContext) {
			const url = new URL(useNuxtApp().ssrContext?.event.node.req.url as string, `http://${useNuxtApp().ssrContext?.event.node.req.headers.host}/`);
			const query = new URLSearchParams(url.search);
			locale = query.get("locale") as string;
		} else {
			locale = useRequestURL().searchParams.get("locale") as string;
		}
	} else {
		if (host?.split(".").length > 1 && host?.split(".")[0] !== "www" && host?.split(".")[0] !== "betway") {
			locale = host?.split(".")[0];
		}
	}

	let localeString = "en-US";
	if (locale) {
		const localConfig = store.config?.cultures.find((cult) => cult.languageCode === locale?.toUpperCase() || cult.cultureCode === locale);
		if (localConfig?.cultureCode) {
			localeString = localConfig?.cultureCode;
		}
	} else {
		const defaultLang = store.config?.cultures[0];
		if (defaultLang?.cultureCode) {
			localeString = defaultLang?.cultureCode;
		}
	}

	store.setInitialLocale(localeString);
};

export default initialiseLocale;
